<template>
  <div class="border border-primary p-2">
    <b-alert variant="info" :show="advancedSearch.length == 0" class="mb-2">
      <em class="fa fa-info-circle mr-2"></em
      >{{ $t("commons.no_search_criteria") }}
    </b-alert>
    <div
      class="row mb-2"
      v-for="(criteria, index) in advancedSearch"
      :key="index"
    >
      <div class="col-3 pl-3 pr-1">
        <b-input-group>
          <template #prepend>
            <b-button variant="danger" @click="deleteCriteria(index)"
              ><em class="fa fa-times"></em
            ></b-button>
          </template>
          <b-form-input
            v-model="criteria.key"
            placeholder="Enter name"
            @input="updateSearchKey($event, index)"
            :disabled="states.searching"
          />
        </b-input-group>
      </div>
      <div class="col-1 pl-0 pr-1">
        <b-form-select
          variant="primary"
          v-model="criteria.operator"
          :options="operators"
          @input="updateSearchOperator($event, index)"
        ></b-form-select>
      </div>
      <div class="col-1 pl-0 pr-0">
        <b-form-select
          variant="primary"
          v-model="criteria.dataType"
          :options="dataTypes"
          @input="updateSearchDataType($event, index)"
        ></b-form-select>
      </div>
      <div class="col-7 pl-1 pr-3">
        <b-form-input
          v-model="criteria.value"
          placeholder="Enter a value"
          @input="updateSearchValue($event, index)"
          :disabled="states.searching"
        />
      </div>
    </div>
    <b-button variant="success" @click="addNewRow">
      <em class="fa fa-plus"></em>
    </b-button>
  </div>
</template>

<script>
import { useSearch } from "../../stores/search";
export default {
  computed: {
    advancedSearch() {
      return this.useSearch.advancedSearch;
    },
    states() {
      return this.useSearch.states;
    },
    operators() {
      return this.useSearch.operators;
    },
    dataTypes() {
      return this.useSearch.dataTypes;
    },
  },
  methods: {
    addNewRow() {
      this.useSearch.addNewCriteria();
    },
    updateSearchKey(text, index) {
      this.useSearch.updateSearchCriteria({
        index: index,
        data: {
          key: text,
        },
      });
    },
    updateSearchValue(text, index) {
      this.useSearch.updateSearchCriteria({
        index: index,
        data: {
          value: text,
        },
      });
    },
    updateSearchOperator(operator, index) {
      this.useSearch.updateSearchCriteria({
        index: index,
        data: {
          operator: operator,
        },
      });
    },
    updateSearchDataType(dataType, index) {
      this.useSearch.updateSearchCriteria({
        index: index,
        data: {
          dataType: dataType,
        },
      });
    },
    deleteCriteria(index) {
      this.useSearch.deleteCriteria(index);
    },
  },
  data() {
    return {
      useSearch: useSearch()
    }
  },
};
</script>
